// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3-lQ4","title":"BackImages_title__j3RGv","images":"BackImages_images__lCKOX"};